import CookiesJS from 'js-cookie';

/**
 * Obtiene y parsea de forma segura la cookie dataUser
 * @returns {Object|null} Objeto parseado o null si no existe
 */
export const getDataUser = () => {
  try {
    const dataUser = CookiesJS.get('dataUser');
    return dataUser ? JSON.parse(dataUser) : null;
  } catch (error) {
    console.error('Error parsing dataUser cookie:', error);
    return null;
  }
};

/**
 * Obtiene y parsea de forma segura la cookie dataClient
 * @returns {Object|null} Objeto parseado o null si no existe
 */
export const getDataClient = () => {
  try {
    const dataClient = CookiesJS.get('dataClient');
    return dataClient ? JSON.parse(dataClient) : null;
  } catch (error) {
    console.error('Error parsing dataClient cookie:', error);
    return null;
  }
};

/**
 * Obtiene el idLanguage del usuario de forma segura
 * @returns {number|null} idLanguage o null si no existe
 */
export const getIdLanguage = () => {
  try {
    const idLng = CookiesJS.get("idLng");
    if (idLng) {
      return JSON.parse(idLng);
    }
    
    const dataUser = getDataUser();
    return dataUser?.user?.idLanguage || null;
  } catch (error) {
    console.error('Error getting idLanguage:', error);
    return null;
  }
};

/**
 * Obtiene el idClient de forma segura
 * @returns {number|null} idClient o null si no existe
 */
export const getIdClient = () => {
  try {
    const dataClient = getDataClient();
    return dataClient?.idClient || null;
  } catch (error) {
    console.error('Error getting idClient:', error);
    return null;
  }
};
